import {
  getObjects,
  getObject,
  addObject,
  updateObject,
  deleteObject,
  getObjectsWithParams,
} from "./Api";

// Wards
export const listWards = async (params = {}, token = "") => {
  return await getObjectsWithParams("wards", params, token);
};

export const getWard = async (id, token = "") => {
  return await getObject("wards", id, token);
};

export const createWard = async (data, token = "") => {
  return await addObject("wards", data, token);
};

export const updateWard = async (id, data, token = "") => {
  return await updateObject("wards", data, id, token);
};

export const deleteWard = async (id, token = "") => {
  return await deleteObject("wards", id, token);
};

// Rooms
export const listRooms = async (params = {}, token = "") => {
  return await getObjectsWithParams("rooms", params, token);
};

export const getRoom = async (id, token = "") => {
  return await getObject("rooms", id, token);
};

export const createRoom = async (data, token = "") => {
  return await addObject("rooms", data, token);
};

export const updateRoom = async (id, data, token = "") => {
  return await updateObject("rooms", data, id, token);
};

export const deleteRoom = async (id, token = "") => {
  return await deleteObject("rooms", id, token);
};

// Beds
export const listBeds = async (params = {}, token = "") => {
  return await getObjectsWithParams("beds", params, token);
};

export const getBed = async (id, token = "") => {
  return await getObject("beds", id, token);
};

export const createBed = async (data, token = "") => {
  return await addObject("beds", data, token);
};

export const updateBed = async (id, data, token = "") => {
  return await updateObject("beds", data, id, token);
};

export const deleteBed = async (id, token = "") => {
  return await deleteObject("beds", id, token);
};
